import type { CmdbObjectTypeId } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import type { ActionApi } from '../../common/types';

export const setCurrentOTMeatballMenu =
	(objectTypeId: CmdbObjectTypeId | null): ActionApi =>
	({ setState }) => {
		setState({ currentOTMeatballMenu: objectTypeId });
	};
